import { IconToggleStarOn12 } from '@cian/ui-kit-design-tokens/icons';

import { type ReactNode } from 'react';

import styles from './SuperAgentIcon.css';

export function SuperAgentIcon(): ReactNode {
  return (
    <div className={styles['circle']}>
      <IconToggleStarOn12 color="text-inverted-default" />
    </div>
  );
}
